import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { addServiceToCart } from '../queries/cart-mutations.graphql';
import { handleCompleteAddService, handleAddServiceToCart } from '../helpers/add-service-to-cart';
import { IAddServiceToCart } from '../types/add-service-to-cart';

export const useAddServiceToCart = ({ refetchCart, onMutationComplete }: IAddServiceToCart) => {
  const [addServiceQuery, { data: dataAddService, loading: loadingAddService, error: errorAddService }] = useMutation(
    addServiceToCart,
    {
      onCompleted: handleCompleteAddService({ refetchCart, onMutationComplete }),
    }
  );

  const addServiceToCartFn = useCallback(handleAddServiceToCart({ addServiceQuery }), []);

  return {
    addServiceToCartFn,
    dataAddService,
    loadingAddService,
    errorAddService,
  };
};
